import { apiClient } from './apiClient';

export const getReservations = async (params = {}) => {
  const {
    page = 0,
    size = 20,
    status = '',
    storeId = '',
    customerId = '',
    startFrom = '',
    startTo = '',
    search = '',
  } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('size', size);
  if (status) queryParams.append('status', status);
  if (storeId) queryParams.append('storeId', storeId);
  if (customerId) queryParams.append('customerId', customerId);
  if (startFrom) queryParams.append('startFrom', startFrom);
  if (startTo) queryParams.append('startTo', startTo);
  if (search) queryParams.append('search', search);

  return await apiClient(`/admin/reservations?${queryParams.toString()}`, { method: 'GET' }, true);
};

export const cancelReservation = async (reservationNumber, cancelReason) => {
  return await apiClient(`/admin/reservations/${reservationNumber}/cancel`, {
    method: 'POST',
    body: JSON.stringify({ cancelReason }),
  }, true);
};

export const getReservationStatusLabel = (status) => {
  const labels = {
    CONFIRMED: '예약',
    IN_USE: '사용중',
    COMPLETED: '이용완료',
    CANCELLED: '취소',
    NO_SHOW: '노쇼',
  };
  return labels[status] || status;
};

export const getReservationStatusOptions = () => [
  { value: '', label: '전체' },
  { value: 'CONFIRMED', label: '예약' },
  { value: 'IN_USE', label: '사용중' },
  { value: 'COMPLETED', label: '이용완료' },
  { value: 'CANCELLED', label: '취소' },
  { value: 'NO_SHOW', label: '노쇼' },
];

export const getPaymentStatusLabel = (status) => {
  const labels = {
    PENDING: '대기',
    COMPLETED: '결제완료',
    FAILED: '실패',
    REFUNDED: '환불',
  };
  return labels[status] || status || '-';
};